module.exports = __webpack_public_path__ + "img/mascot.e70e9d66.svg";